module.exports = __webpack_public_path__ + "static/img/products application_rooftop3.6da91f8d.jpg";